<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-4">
        <h2>
          <Button v-if="appliances.length>0" style="float: right" type="button"
            :label="$t('dashboard.add_appliance_button')" @click="() => addDialog=true " icon="irinox-icon-button pi pi-plus" iconPos="left"  />
          {{$t('dashboard.title')}}
        </h2>
				<div v-if="appliances.length==0" class="no-appliances p-grid p-jc-center p-ai-end vertical-container" style="background-image: url('assets/irinox/images/appliances/devices-empty.png')">
            <div class="p-col-12 p-md-8 p-lg-8 p-xl-6">
                <div class="box p-text-center">
                  <p>{{$t('dashboard.no_appliances')}}</p>
                  <Button :label="$t('dashboard.add_appliance_button')" type="button" @click="() => addDialog=true" icon="irinox-icon-button pi pi-plus" iconPos="left" ></Button>
                </div>
            </div>
        </div>
				<div v-else class="dashboard">

            <div class="irinox-form">
              <div class="p-formgroup-inline p-ai-center">
                <div class="p-field">
                  <Dropdown v-model="filter.lab" :options="laboratories" optionLabel="name" optionValue="code"
                    :placeholder="$t('dashboard.filter_lab_ph')" />
                </div>
                <div class="p-field">
                  <Dropdown v-model="filter.category" :options="categories" optionLabel="name" optionValue="code"
                    :placeholder="$t('dashboard.filter_category_ph')" />
                </div>
                <div class="p-field">
                  <Dropdown v-model="filter.status" :options="statuses" optionLabel="name" optionValue="code"
                    :placeholder="$t('dashboard.filter_status_ph')" />
                </div>
              </div>
            </div>

            <DataView :value="appliancesFiltered" :layout="'grid'" :rows="9" 
                :paginator="true" paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
                currentPageReportTemplate="{currentPage} / {totalPages}"
                :sortField="applianceName" :sortOrder="1"
                style="margin: 0 -1rem">

              <template #empty>
                <div class="p-m-4">{{$t('dashboard.filter_no_appliances')}}</div>
              </template>

              <template #grid="slotProps">
                <div class="p-col-12 p-sm-12 p-md-12 p-lg-6 p-xl-4" >
                  <div class="card p-mx-2 p-mt-2 p-mb-3 appliance-card" @click="applianceDetail(slotProps.data.serialNumber)">

                    <div class="dashboard-plan-badges">
                      <div v-if="hasPlanActive(slotProps.data, 'PLUS')" class="plan-badge">
                        <div class="plan-plus">
                          <img src="/assets/irinox/icons/plans/plus.svg" :alt="$t('admin.plans.table_badge_active_plus')" />
                        </div>
                      </div>
                      <div v-else-if="hasPlanActive(slotProps.data, 'PREMIUM')" class="plan-badge">
                        <div class="plan-premium">
                          <img src="/assets/irinox/icons/plans/premium.svg" :alt="$t('admin.plans.table_badge_active_premium')" />
                        </div>
                      </div>
                      <div v-if="hasPlanActive(slotProps.data, 'GELATERIA')" class="plan-badge">
                        <div class="plan-gelateria">
                          <img src="/assets/irinox/icons/plans/gelateria.svg" :alt="$t('admin.plans.table_badge_active_gelateria')" />
                        </div>
                      </div>
                    </div>
                    <div class="dashboard-plan-badges-activable">
                      <div v-if="hasPlanActivable(slotProps.data, 'PLUS') && !hasPlanActivable(slotProps.data, 'PREMIUM') && !hasPlanActive(slotProps.data, 'PREMIUM')" class="plan-badge">
                        <div class="plan-plus small">{{$t('admin.plans.table_badge_activable_plus')}}</div>
                      </div>
                      <div v-else-if="hasPlanActivable(slotProps.data, 'PREMIUM') && !hasPlanActive(slotProps.data, 'PLUS')" class="plan-badge">
                        <div class="plan-premium small">{{$t('admin.plans.table_badge_activable_premium')}}</div>
                      </div>
                      <div v-if="hasPlanActivable(slotProps.data, 'GELATERIA')" class="plan-badge">
                        <div class="plan-gelateria small">{{$t('admin.plans.table_badge_activable_gelateria')}}</div>
                      </div>
                    </div>

                    <i v-if="slotProps.data.alarms!=null && slotProps.data.alarms.length>0" class="alert" style="background-image: url('assets/irinox/icons/alert.svg')" v-tooltip.left="$functions.alarmTooltip(slotProps.data.alarms, $t)"/>
                    <i v-if="isAnomalyActive(slotProps.data) && $config.maintenanceEnabled()" :class="['anomaly',{'anomaly-first':slotProps.data.alarms==null || slotProps.data.alarms.length==0}]" style="background-image: url('assets/irinox/icons/maintenance.svg')" v-tooltip.left="$t('dashboard.anomaly_tooltip')"/>
                    
                    <div class="p-grid nested-grid p-ai-center vertical-container">
                    
                      <div class="p-col-fixed small-padding" style="width:105px; height: 186px; display: flex; align-items: center;">
                        <img :src="$images.image(slotProps.data.modelNumber, slotProps.data.accessory)" style="max-width:100px; max-height: 186px;" :alt="slotProps.data.modelNumber"/>
                      </div>
                     
                        <div class="p-col-fixed small-padding p-grid vertical-container" style="width: calc(100% - 80px);">
                    
                          <div class="p-col small-padding p-as-center" style="min-height: 105px; min-width: 170px;">
                              <div class="model-number">{{applianceName(slotProps.data)}}</div>
                              <div class="lab-name">{{slotProps.data.labName ?? '-'}}</div>
                          </div>
                    
                          <div class="p-col small-padding p-as-start" style="min-height: 140px; min-width: 170px;">
                              
                              <div class="status">
                                <div v-if="slotProps.data.online" class="status-online" style="background-image: url('assets/irinox/icons/status_online.svg')">
                                  {{$t('dashboard.statuses.connected')}}
                                </div>
                                <div v-else class="status-offline" style="background-image: url('assets/irinox/icons/status_offline.svg')">
                                  {{$t('dashboard.statuses.disconnected')}}
                                </div>
                              </div>

                              <div class="cycle p-text-center">

                                <div v-if="slotProps.data.type=='ABBATTITORE' && slotProps.data.gamma=='MF Next'">
                                  <!-- MF Next -->
                                  <div v-if="mfCycleRunning(slotProps.data) && slotProps.data.cycle" class="cycle-running">
                                    <div class="icon">
                                      <i :class="['cycle-spinner',{'cycle-spinner-spin': !(slotProps.data.cycle.cycleProgressPercentage && slotProps.data.cycle.cycleTimeLeft>0)}]"><span :class="cycles[slotProps.data.gamma][slotProps.data.cycle.functionRunning].icon" style="font-size: 35px;"/></i>
                                    </div>
                                    <div class="description">
                                      {{slotProps.data.cycle.runningCycleName}}
                                    </div>
                                    <div class="progress">
                                      <ProgressBar v-if="slotProps.data.cycle.cycleProgressPercentage && slotProps.data.cycle.cycleTimeLeft>0" :value="slotProps.data.cycle.cycleProgressPercentage" :showValue="false" :arial-label="slotProps.data.cycle.runningCycleName"/>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div class="icon"></div>
                                    <div class="description">
                                      <!-- <span v-if="slotProps.data.online">{{$t('mf.no_cycle_running')}}</span> -->
                                    </div>
                                    <div class="progress"></div>
                                  </div>
                                </div>

                                <div v-if="slotProps.data.type=='ABBATTITORE' && slotProps.data.gamma=='EF Next'">
                                  <!-- EF Next -->
                                  <div v-if="efCycleRunning(slotProps.data) && slotProps.data.cycle" class="cycle-running">
                                    <div class="icon">
                                      <i :class="['cycle-spinner',{'cycle-spinner-spin': !(/*slotProps.data.cycle.cycleProgressPercentage &&*/ slotProps.data.cycle.cycleTimeLeft>0)}]"><span :class="cycles[slotProps.data.gamma][slotProps.data.cycle.functionRunning].icon" style="font-size: 35px;"/></i>
                                    </div>
                                    <div class="description">
                                      {{slotProps.data.cycle.runningCycleName}}
                                    </div>
                                    <div class="progress">
                                      <!-- <ProgressBar v-if="slotProps.data.cycle.cycleProgressPercentage && slotProps.data.cycle.cycleTimeLeft>0" :value="slotProps.data.cycle.cycleProgressPercentage" :showValue="false" /> -->
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div class="icon"></div>
                                    <div class="description">
                                      <!-- <span v-if="slotProps.data.online">{{$t('mf.no_cycle_running')}}</span> -->
                                    </div>
                                    <div class="progress"></div>
                                  </div>
                                </div>

                                <div v-if="slotProps.data.type=='ABBATTITORE' && slotProps.data.gamma=='SF'">
                                  <!-- SF -->
                                  <div v-if="efCycleRunning(slotProps.data) && slotProps.data.cycle" class="cycle-running">
                                    <div class="icon">
                                      <i :class="['cycle-spinner',{'cycle-spinner-spin': !(/*slotProps.data.cycle.cycleProgressPercentage &&*/ slotProps.data.cycle.cycleTimeLeft>0)}]"><span :class="cycles[slotProps.data.gamma][slotProps.data.cycle.functionRunning].icon" style="font-size: 35px;"/></i>
                                    </div>
                                    <div class="description">
                                      {{slotProps.data.cycle.runningCycleName}}
                                    </div>
                                    <div class="progress">
                                      <!-- <ProgressBar v-if="slotProps.data.cycle.cycleProgressPercentage && slotProps.data.cycle.cycleTimeLeft>0" :value="slotProps.data.cycle.cycleProgressPercentage" :showValue="false" /> -->
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div class="icon"></div>
                                    <div class="description">
                                      <!-- <span v-if="slotProps.data.online">{{$t('mf.no_cycle_running')}}</span> -->
                                    </div>
                                    <div class="progress"></div>
                                  </div>
                                </div>

                                <div v-else-if="slotProps.data.type=='ABBATTITORE' && slotProps.data.gamma=='MYA'">
                                  <!-- MYA -->
                                  <div v-if="myaCycleRunning(slotProps.data) && slotProps.data.cycle" class="cycle-running">
                                    <div class="icon">
                                      <i :class="['cycle-spinner']"><span :style="myaIconStyle(slotProps.data)"/></i>
                                    </div>
                                    <div class="description">
                                      {{$t('mya.cycles.'+myaRunningCycleId(slotProps.data))}}
                                    </div>
                                    <div class="progress">
                                      <ProgressBar v-if="slotProps.data.cycle.cycleProgressPercentage && slotProps.data.cycle.cycleTimeLeft>0" :value="slotProps.data.cycle.cycleProgressPercentage" :showValue="false" :aria-label="$t('mya.cycles.'+myaRunningCycleId(slotProps.data))"/>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div class="icon"></div>
                                    <div class="description">
                                      <!-- <span v-if="slotProps.data.online">{{$t('mya.no_cycle_running')}}</span> -->
                                    </div>
                                    <div class="progress"></div>
                                  </div>
                                </div>

                                <div v-else-if="slotProps.data.type=='CONSERVATORE'">
                                  <!-- CP Next -->
                                  <div v-if="slotProps.data.status && slotProps.data.status.operationalStatus && slotProps.data.status.operationalStatus!='standby'" class="cycle-running">
                                    <div class="icon">
                                      <i :class="['cycle-spinner',{'cycle-spinner-spin':cycles[slotProps.data.gamma][slotProps.data.status.operationalStatus].loader}]"><span :class="cycles[slotProps.data.gamma][slotProps.data.status.operationalStatus].icon" style="font-size: 35px;"/></i>
                                    </div>
                                    <div class="description">
                                      <span v-if="slotProps.data.status.operationalStatus=='defrost'">{{$t('cp.phases.defrost')}}</span>
                                      <span v-if="slotProps.data.status.operationalStatus=='cool'">{{$functions.temperature(slotProps.data.status.T1ProbeMeasure, isCelsius)}} {{unit}}</span>
                                    </div>
                                    <div class="progress"></div>
                                  </div>
                                  <div v-else>
                                    <div class="icon">
                                      <!-- <i v-if="slotProps.data.online" :class="['cycle-spinner',{'cycle-spinner-spin':cycles[slotProps.data.gamma]['standby'].loader}]"><span :class="cycles[slotProps.data.gamma]['standby'].icon" style="font-size: 35px;"/></i> -->
                                    </div>
                                    <div class="description">
                                      <!-- <span v-if="slotProps.data.online">- {{unit}}</span> -->
                                    </div>
                                    <div class="progress"></div>
                                  </div>
                                </div>

                                <div v-else-if="slotProps.data.type=='FERMALIEVITA'">
                                  <!-- MP Next -->
                                  <div v-if="slotProps.data.status && slotProps.data.status.mode!=null && slotProps.data.status.mode!==0" class="cycle-running">
                                    <div class="icon">
                                      <i :class="['cycle-spinner',{'cycle-spinner-spin':cycles[slotProps.data.gamma][slotProps.data.status.mode.toString()].loader}]"><span :class="cycles[slotProps.data.gamma][slotProps.data.status.mode.toString()].icon" style="font-size: 35px;"/></i>
                                    </div>
                                    <div class="description">
                                      <span v-if="slotProps.data.status.mode===4">{{$t('cp.phases.defrost')}}</span>
                                      <span v-else>{{$functions.temperature(slotProps.data.status.TCell, isCelsius)}} {{unit}}</span>
                                    </div>
                                    <div class="progress"></div>
                                  </div>
                                  <div v-else>
                                    <div class="icon">
                                      <!-- <i v-if="slotProps.data.online" :class="['cycle-spinner',{'cycle-spinner-spin':cycles[slotProps.data.gamma]['0'].loader}]"><span :class="cycles[slotProps.data.gamma]['0'].icon" style="font-size: 35px;"/></i> -->
                                    </div>
                                    <div class="description">
                                      <!-- <span v-if="slotProps.data.online">- {{unit}}</span> -->
                                    </div>
                                    <div class="progress"></div>
                                  </div>
                                </div>

                                <div v-else>
                                  <!-- ??? -->
                                </div>

                              </div>

                          </div>
                        </div>
                        
                    </div>
                  </div>
                </div>
              </template>

            </DataView>
        </div>
		</div>
	</div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="errorDialog" 
    mode="error" 
    :message="$t('dashboard.error_dialog')"
    :life="3000" 
    @update:visible="errorDialog = $event" />
  <IrinoxDialogDark :visible="blockingErrorDialog" 
    mode="error" 
    :message="$t('dashboard.error_dialog')"
    :life="0" 
    @update:visible="blockingErrorDialog = $event" />

  <!--            -->
  <!-- ADD DIALOG -->
  <!--            -->
  <IrinoxDialogLight :visible="addDialog" 
    mode="appliance"
    :labs="labs"
    @click:open-lab="addLabDialog = true"
    @update:visible="addDialog = $event" 
    @click:button="addAppliance" />
  <IrinoxDialogDark :visible="successAddDialog" 
    mode="success" 
    :message="$t('dashboard.add_dialog_success')"
    :life="3000" 
    @update:visible="successAddDialog = $event" />

  <!--                -->
  <!-- ADD LAB DIALOG -->
  <!--                -->
  <IrinoxDialogLight :visible="addLabDialog" 
    mode="lab"
    @update:visible="addLabDialog = $event" 
    @click:button="addLab" />
  <IrinoxDialogDark :visible="successAddLabDialog" 
    mode="success" 
    :message="$t('laboratories.success_dialog')"
    :life="3000" 
    @update:visible="successAddLabDialog = $event" />

</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import IrinoxDialogLight from '../IrinoxDialogLight.vue';
import cycles from "@/cycles";
import { mapGetters } from 'vuex';

export default {
    components: {
          IrinoxDialogDark,
          IrinoxDialogLight,
    },
    data() {
        return {
          // appliancesFiltered: [],
          labs: [],
          categories: [{ 
              code: null,
              name: this.$t('dashboard.filter_remove') 
            },{ 
              code: "ABBATTITORE",
              name: this.$t('dashboard.categories.ABBATTITORE') 
            },{ 
              code: "CONSERVATORE",
              name: this.$t('dashboard.categories.CONSERVATORE') 
            },{ 
              code: "FERMALIEVITA",
              name: this.$t('dashboard.categories.FERMALIEVITA') 
            }],
          statuses: [{ 
              code: null,
              name: this.$t('dashboard.filter_remove') 
            },{ 
              code: true,
              name: this.$t('dashboard.statuses.connected') 
            },{ 
              code: false,
              name: this.$t('dashboard.statuses.disconnected') 
            }],
          filter: {
            lab: null,
            category: null,
            status: null
          },
          appliancesFiltered: [],
          cycles: cycles.icons,
          errorDialog: false,
          blockingErrorDialog: false,
          addDialog: false,
          successAddDialog: false,
          addLabDialog: false,
          successAddLabDialog: false,
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
          appliances: 'appliances/appliances'
        }),
        laboratories: function() {
          let ls = [{ 
            code: null,
            name: this.$t('admin.appliances.filter_remove') 
          }];
          for(let i=0; i<this.appliances.length; i++) {
            if(this.appliances[i].labName) {
              ls.push({ code: this.appliances[i].labName, name: this.appliances[i].labName });
            }
          }
          return this.$functions.uniqByKeepFirst(ls, item => item.code);
        },
    },
    watch: {
      "appliances": 'filterAppliances',
      "filter.lab": 'filterAppliances',
      "filter.category": 'filterAppliances',
      "filter.status": 'filterAppliances',
    },
    created() {
      // this.$store.commit('appliances/appliances', []);
      this.applianceService = new ApplianceService();
    },
    mounted() {
      this.reloadAppliances();
      this.getLabs();
      setInterval(this.filterAppliances, 5000);
    },
    methods: {
      filterAppliances() {
        this.appliancesFiltered = this.appliances.filter(function(val) {
              let labStatus = this.filter.lab!=null ? val.labName == this.filter.lab : true;
              let catStatus = this.filter.category!=null ? val.type == this.filter.category : true;
              let stsStatus = this.filter.status!=null ? val.online == this.filter.status : true;
              return labStatus && catStatus && stsStatus;
            }.bind(this))
      },
      applianceName(data) {
        return data.name ?? data.modelNumber;
      },
      myaIconStyle(appliance) {
        let myaCycles = this.cycles[appliance.gamma];
        let myaCycle = myaCycles[this.myaRunningCycleId(appliance)];
        if(myaCycle!=null) {
          return 'background-color: #002445; mask: url(\'assets/irinox/icons'+myaCycle.svg+'\') no-repeat 50% 50%; -webkit-mask: url(\'assets/irinox/icons'+myaCycle.svg+'\') no-repeat 50% 50%;'
        } 
        return "";
      },
      reloadAppliances() {
        this.applianceService.getAppliances(this.personaltoken)
          .then((appliances) => {
            this.$store.commit('appliances/appliances', appliances);
            // setTimeout(function() {
            //   this.$store.commit('appliances/offline');
            // }.bind(this),3000);
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.$store.commit('appliances/appliances', []);
            this.errorDialog = true;
          });
      },
      addAppliance(data) {

        this.applianceService.postAppliance(this.personaltoken, data)
          .then((data) => {
            this.addDialog = false;
            if(data.code=="200") {
              this.successAddDialog = true;
              this.reloadAppliances();
            } else {
              console.error("EXCEPTION "+JSON.stringify(data));
              this.errorDialog = true;
            }
          })
          .catch(error => {
            this.addDialog = false;
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });

      },
      getLabs() {
        this.applianceService.getLabs(this.personaltoken)
          .then(labs => {
            this.populateLabs(labs);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.blockingErrorDialog = true;
          });
      },
      populateLabs(labs) {
        this.labs = labs;
        this.labs.sort((a,b) => this.$functions.compareStrings(a, b, "name"));
        this.labs.push({ id: -1, name: this.$t('dashboard.add_dialog_lab_add') });
      },
      addLab(labName) {
        let updateData = {};
        updateData.name = labName;

        this.applianceService.postLabs(this.personaltoken, updateData)
          .then(labs => {
            this.addLabDialog = false;
            this.successAddLabDialog = true;
            this.populateLabs(labs);
          })
          .catch(error => {
            this.addLabDialog = false;
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });

      },
      applianceDetail(serialNumber) {
        this.$router.push({ name: 'appliance-details', params: { serialNumber: serialNumber } });
      },
      mfCycleRunning(appliance) {
        return appliance.online && appliance.cycleRunning && appliance.cycleRunning === 1;
      },
      efCycleRunning(appliance) {
        return appliance.online && appliance.cycleRunning && appliance.cycleRunning === 1 && appliance.cycle?.functionRunning;
      },
      myaCycleRunning(appliance) {
        return appliance.online && appliance.cycleRunning && appliance.cycleRunning === 1;
      },
      myaRunningCycleId: function(appliance) {
        return appliance.cycle && appliance.cycle.runningCycleId!=null ? appliance.cycle.runningCycleId.replace(/.*_/g, '') : null;
      },
      isAnomalyActive(appliance) {
          // //Check if at least one anomaly is active == true
          // return this.appliance.anomalies && this.appliance.anomalies.some(anomaly => anomaly.active === true);
          return appliance.anomaliesToRead;
        },
      hasPlanActive(appliance, planCode) {
        return appliance?.plans?.some(plan => plan.code === planCode && plan.startDate !=null);
      },
      hasPlanActivable(appliance, planCode) {
        return appliance?.plans?.some(plan => plan.code === planCode && plan.startDate == null);
      },
    }
}
</script>

<style scoped>
.no-appliances {
  background-repeat: no-repeat;
  background-position: center -100px;
  background-size: 700px;
  height: 720px;
  color: #6B7280;
  font-size: 25px;
  font-weight: 400;
}

.irinox-form .p-dropdown {
    width: 200px;
}

</style>